{
  "app": {
    "name": "POSS",
    "legend": "Pacific One Stop Shop"
  },
  "dashboard": {
    "statistics": "Statistiken",
    "jurisdictions": "Zuständigkeitsbereiche",
    "pendingDisbursements": "Ausstehende Auszahlungen",
    "payments": "Zahlungen",
    "taxpayers": "Steuerpflichtige",
    "firstPayment": "Erste Zahlung",
    "lastPayment": "Letzte Zahlung"
  },
  "config": {
    "tin": "PIN",
    "tinLegend": "POSS Identification Number"
  },
  "formDefinition": {
    "label": {
      "reconecting": "Wiederverbindung",
      "reconected": "Wieder verbunden"
    }
  },
  "common": {
    "label": {
      "valueType": "Werttyp",
      "theme": "Thema",
      "feedback": "Rückmeldung",
      "logout": "Ausloggen",
      "print": "Zu drucken",
      "phoneNumberArea": "Bereich",
      "newRecord": "Neu",
      "editRecord": "Aktualisieren",
      "current-user": "Aktueller Benutzer",
      "user-profile": "Benutzerprofil",
      "name": "Name",
      "givenNames": "Namen",
      "surnames": "Nachnamen",
      "search": "Suchen",
      "clean": "Aufräumen",
      "create": "Neu",
      "ok": "Akzeptieren",
      "next": "Nächster",
      "cancel": "Stornieren",
      "back": "Hinter",
      "edit": "Bearbeiten",
      "actions": "Aktionen",
      "selectAction": "Aktion auswählen",
      "send": "Senden",
      "close": "Schließen",
      "add": "Hinzufügen",
      "email": "Mail",
      "phoneNumber": "Telefon",
      "id": "Gehen",
      "password": "Passwort",
      "state": "Deaktiviert",
      "translation": "Übersetzung",
      "language": "Idiom",
      "value": "Wert",
      "translatable": "Übersetzbar",
      "politicalDivision": "Politische Spaltung",
      "department": "Abteilung / Provinz / Staat",
      "city": "Stadt, Dorf",
      "zipCode": "Postleitzahl",
      "cellPhone": "Handy, Mobiltelefon",
      "personType": "Art von Person",
      "businessName": "Name oder sozialer Grund",
      "taxpayerName": "Name oder sozialer Grund",
      "tradeName": "Handelsname",
      "address": "Richtung",
      "country": "Land",
      "localization": "Ort",
      "website": "Webseite",
      "fileSearch": "Datei durchsuchen",
      "fileRequirements": "PDF · Max. 9,6 MB",
      "fileUploading": "Wird hochgeladen...",
      "fileUploaded": "Hochgeladen",
      "fileUploadError": "Die Datei konnte nicht hochgeladen werden",
      "fileSelect": "Auswählen",
      "fileReplace": "Ersetzen",
      "fileRemove": "Entfernen",
      "fileRemoving": "Wird entfernt...",
      "fileRemoveError": "Die Datei konnte nicht entfernt werden",
      "fileUpload": "Datei hochladen",
      "fileDownload": "Download-Datei",
      "noFileSelected": "Keine Datei ausgewählt",
      "dateFrom": "Stammen aus",
      "dateTo": "Datum bis",
      "noFound": "Es gibt kein Ergebnis",
      "taxReturnCurrency": "Erklärung Moneda",
      "page-showing": "Zeigen",
      "page-to": "zu",
      "page-of": "von",
      "page-entries": "Aufzeichnungen",
      "loading": "Laden ...",
      "error": "Fehler",
      "unableToLoad": "Daten konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
      "retry": "Wiederholen",
      "currency": "Währung",
      "paymentMethod": "Zahlungsmethode",
      "attachment": "Anfügen",
      "paymentReference": "Weitere Informationen",
      "supportDocument": "Support-Dokument",
      "payment": "Zahlung",
      "backToHome": "Zurück nach oben",
      "createdBy": "Erstellt von",
      "bank": "Bank",
      "bankInformation": "Bankinformationen",
      "excel": "Excel",
      "days": {
        "monday": "Mo.",
        "tuesday": "Ma",
        "wednesday": "Mich",
        "thursday": "Do",
        "friday": "Fr.",
        "saturday": "Sa.",
        "sunday": "So"
      },
      "months": {
        "january": "Januar",
        "february": "Februar",
        "march": "März",
        "april": "April",
        "may": "Kann",
        "june": "Juni",
        "july": "Juli",
        "august": "August",
        "september": "September",
        "october": "Oktober",
        "november": "November",
        "december": "Dezember"
      },
      "type": "Nett",
      "numeric": "Numerisch",
      "date": "Datum",
      "list": "Bereit",
      "text": "Text",
      "header": "Kopfteil",
      "description": "Beschreibung",
      "ommited": "Weggelassen",
      "all": "Alle",
      "see": "Sehen",
      "filters": "Filter"
    },
    "descriptions": {
      "taxReturnCurrency": "Währung, die für Erklärungen verwendet werden soll",
      "can-access": "Ermöglicht den Zugriff auf",
      "contactTaxIdNumber-tax": "Steueridentifikationsnummer des Kontakts im Wohnsitzland"
    },
    "button": {
      "add": "Hinzufügen",
      "edit": "Bearbeiten",
      "find": "Suchen",
      "cancel": "Stornieren",
      "delete": "Beseitigen, abschütteln",
      "save": "Behalten",
      "clean": "Aufräumen",
      "new": "Neu",
      "show": "Uhr",
      "download": "Herunterladen",
      "file": "Anfügen",
      "previous": "Bisherige",
      "next": "Nächster",
      "send": "Senden",
      "translate": "Übersetzungen",
      "return": "Rückkehr",
      "continue": "Fortsetzen",
      "newVersion": "Neue Version"
    },
    "dialog": {
      "dialog-error": "Fehler",
      "table-title-header": "Mitteilungen",
      "warning-title": "Beachtung"
    },
    "messages": {
      "error-500": "Auf dem Server ist ein Fehler aufgetreten. Wenden Sie sich an den Administrator.",
      "fileUpload": "Die Datei wurde erfolgreich hochgeladen",
      "savedSucessfully": "Erfolgreich gespeichert",
      "deletedSucessfully": "Erfolgreich entfernt",
      "pleaseWait": "Warten Sie mal",
      "nofileContent": "Die Datei hat keinen Inhalt",
      "errorMessageSystem": "Der Parameter '$ {code}' wurde im Katalog nicht gefunden",
      "warningInactiveSession": "Achtung: Seit einiger Zeit wurde keine Aktivität festgestellt. Die Sitzung wird in 1 Minute geschlossen, wenn noch keine Aktivität erkannt wurde",
      "sessionIdleCountdown": "Ihre Sitzung wird in {{count}} Sekunden geschlossen.",
      "closingSession": "Abschlusssitzung ...",
      "confirm": "Möchten Sie diese Aktion sicherstellen?",
      "uploadProcessing": "Die Informationen wurden hochgeladen und werden verarbeitet, Sie werden benachrichtigt, sobald die Verarbeitung abgeschlossen ist.",
      "messageSent": "Nachricht erfolgreich gesendet"
    },
    "validations": {
      "nameRequired": "Das Feld Name ist erforderlich",
      "fieldRequired": "Dieses Feld ist erforderlich",
      "numbersAndLetters": "Nur Zahlen und Buchstaben",
      "email": "Ungültige E-Mail",
      "minStringValue": "Das Feld muss mindestens {{min}} Zeichen enthalten",
      "maxStringValue": "Das Feld darf maximal {{max}} Zeichen enthalten",
      "minNumberValue": "Der Feldwert muss mindestens {{min}} sein",
      "maxNumberValue": "Der Feldwert muss maximal {{max}} sein"
    },
    "languages": {
      "spanish": "Spanisch (Spanien)",
      "english": "Englisch (USA)"
    },
    "taxpayer-request-types": {
      "enroll": "Registrierung",
      "update": "Aktualisierung",
      "unsubscribe": "Abmelden"
    },
    "taxpayer-request-states": {
      "pending": "Ohrring",
      "pending_additional_information": "Weitere Informationen ausstehend",
      "approved": "Genehmigt",
      "rejected": "Abgelehnt"
    },
    "taxreturn-types": {
      "original": "Original",
      "amending": "Berichtigung"
    },
    "taxreturn-status": {
      "pending": "Ohrring",
      "accepted": "Akzeptiert",
      "approved": "Genehmigt",
      "rejected": "Abgelehnt",
      "reconciled": "Abgestimmt"
    },
    "yes-no": {
      "yes": "Ja",
      "no": "NICHT"
    }
  },
  "inbox-notifications": {
    "title": {
      "inbox": "Briefkasten"
    },
    "label": {
      "message": "Botschaft",
      "messages": "Mitteilungen",
      "read": "Lesen",
      "inboxDate": "Datum",
      "ok": "JA",
      "no": "NICHT"
    }
  },
  "management-report": {
    "label": {
      "taxpayerByCountry": "Für Land",
      "taxpayerByOperation": "Durch Betrieb",
      "taxpayerAmount": "Menge",
      "taxAmount": "Nach Steuern",
      "dateFrom": "Daten von",
      "dateTo": "Datum bis"
    },
    "title": {
      "pageTaxpayer": "Mitwirkende",
      "pageTaxreturn": "Erklärungen",
      "pagePayment": "Zahlungen"
    },
    "validations": {
      "dateRequired": "Dieses Datum ist erforderlich",
      "dateToGreaterThan": "Das Datum muss größer sein als das Ab-Datum",
      "dateLessThreeMonths": "Das Datum muss weniger als 12 Monate nach dem Ab-Datum liegen"
    }
  },
  "non-compliances": {
    "label": {
      "period": "Zeitraum",
      "expirationDate": "Verfallsdatum",
      "NotificationDate": "Benachrichtigungsdatum",
      "presentationDate": "Präsentationsdatum",
      "wait": "Warte ab",
      "penalty": "Strafe",
      "declarationAmount": "Deklarationsbetrag",
      "paymentAmount": "Zahlungsbetrag",
      "days": "tage",
      "countTaxpayerNotified": "Benachrichtigungen",
      "countTaxpayerCompliance": "Komplimente",
      "compliancePercentage": "Beachtung",
      "elapsedTime": "Durchschnittliche Zeit",
      "debtGenerated": "Entstandene Schulden"
    },
    "title": {
      "nonCompliancesTax": "Nichteinhaltung aufgrund von Steuern",
      "nonCompliances": "Nichteinhaltungen",
      "nonCompliancesPayments": "Ausstehende Zahlungen",
      "StatisticQuery": "Beratungszeitraum",
      "StatisticQueryResult": "Ergebnisse"
    }
  },
  "operations-economy-activity": {
    "title": {
      "page": "Wirtschaftstätigkeit"
    },
    "label": {
      "code": "Code",
      "name": "Name",
      "description": "Beschreibung",
      "newButton": "Neu",
      "saveButton": "Behalten"
    },
    "header": {
      "code": "Code",
      "name": "Name",
      "description": "Beschreibung",
      "actions": "Aktionen"
    },
    "button": {
      "cancel": "Stornieren",
      "delete": "Beseitigen, abschütteln",
      "save": "Behalten",
      "search": "Suchen",
      "new": "Neu",
      "clean": "Aufräumen",
      "ok": "Akzeptieren"
    },
    "validations": {
      "codeRequired": "Der Code ist erforderlich",
      "nameRequired": "Der Name ist erforderlich",
      "descriptionRequired": "Beschreibung ist erforderlich"
    },
    "messages": {
      "confirmTitle": "Beseitigen, abschütteln",
      "confirmDeleted": "Sind Sie sicher, diese Informationen zu löschen?",
      "deletedSucessfully": "Wurde erfolgreich entfernt",
      "savedSucessfully": "Gespeicherte Informationen",
      "error": "Error"
    }
  },
  "parameters-catalog": {
    "title": {
      "catalogType": "Katalogtyp",
      "catalog": "Katalog"
    },
    "label": {
      "type": "Nett",
      "name": "Name",
      "description": "Beschreibung",
      "field": "Landschaft",
      "label": "Hashtag",
      "parent": "Papa",
      "newCatalogType": "neue Art von Katalog",
      "newCatalog": "Neuer Katalog",
      "code": "Code",
      "addDefinition": "Definition hinzufügen",
      "newDefinition": "Neue Definition",
      "extaFilds": "Zusätzliche Benutzerfelder",
      "addNameTraslation": "Übersetzung hinzufügen"
    },
    "validations": {
      "exists": "Der Datensatz ist bereits vorhanden",
      "letterNumberhyphen": "Es sind nur Buchstaben, Zahlen und Bindestriche zulässig"
    },
    "messages": {
      "languageExist": "Die Sprache wurde bereits hinzugefügt"
    }
  },
  "parameters-enviroments": {
    "title": {
      "page-security": "Umgebungsvariablen (Sicherheit)",
      "page-application": "Umgebungsvariablen (Anwendung)"
    },
    "label": {
      "name": "Name",
      "type": "Nett",
      "value": "Wert",
      "newButton": "Neu",
      "saveButton": "Behalten"
    },
    "validations": {
      "nameRequired": "Das Feld Name ist erforderlich",
      "typeRequired": "Das Feld Typ ist erforderlich",
      "textValueRequired": "Das Feld Wert ist erforderlich"
    },
    "messages": {
      "savedSucessfully": "Zufriedenstellend gespeichert",
      "error": "Error"
    }
  },
  "home-template": {
    "title": {
      "page-home": "Landingpage-Vorlage",
      "page-terms": "Vorlagenbedingungen"
    },
    "label": {
      "template": "Vorlage"
    },
    "messages": {
      "savedSucessfully": "Erfolgreich gespeichert"
    }
  },
  "parameters-notification-template": {
    "title": {
      "page-application": "Benachrichtigungen App",
      "page-security": "Sicherheitsbenachrichtigungen"
    },
    "label": {
      "template": "Vorlage",
      "emailNotification": "Benachrichtigen Sie per E-Mail",
      "pushNotification": "Mailbox benachrichtigen",
      "newTemplate": "Neue Vorlage",
      "id": "ID-Vorlage",
      "subject": "Subject",
      "inbox": "Tablett"
    },
    "validations": {
      "templateRequired": "Vorlage ist erforderlich"
    }
  },
  "taxpayer-fields": {
    "title": {
      "page": "Mitwirkende Felder",
      "enabled": "aktiviert"
    },
    "header": {
      "fieldCode": "Code",
      "fieldName": "Name",
      "fieldSection": "Abschnitt",
      "actions": "aktiviert"
    },
    "messages": {
      "savedSucessfully": "Informationen erfolgreich gespeichert"
    }
  },
  "administration-user": {
    "title": {
      "page": "Benutzer",
      "page-taxpayer": "Mitwirkende",
      "page-disable-tfa": "Deaktivieren Sie die Double Factor Authentication (2FA)",
      "activation-link-confirmation": "Aktivierungslink bestätigen"
    },
    "label": {
      "userName": "Nutzername",
      "department": "Abteilung",
      "roles": "Rollen",
      "general-information": "Allgemeine Informationen",
      "user": "Neuer Benutzer",
      "edit-user": "Benutzer bearbeiten",
      "disabled": "Deaktiviert",
      "email-confirmed": "E-Mail bestätigt",
      "invitation-sent-at": "Einladung gesendet am",
      "invitation-not-sent": "Nicht gesendet",
      "locale": "Bevorzugte Sprache",
      "disable": "Etwas deaktivieren",
      "enable": "Aktivieren",
      "cancel": "Stornieren",
      "return": "Zurück"
    },
    "button": {
      "send-activation-link": "Aktivierungslink senden",
      "resend-activation-link": "Aktivierungslink erneut senden"
    },
    "validations": {
      "userName": "Ein Benutzername wird benötigt"
    },
    "messages": {
      "disableTitle": "Benutzer deaktivieren",
      "confirmDisable": "Möchten Sie diesen Benutzer wirklich deaktivieren?",
      "confirmEnable": "Möchten Sie diesen Benutzer wirklich aktivieren?",
      "savedSucessfully": "Erfolgreich gespeichert",
      "enableTitle": "Benutzer aktivieren",
      "error": "Error",
      "confirmDisableTfaTitle": "Deaktivieren Sie 2FA",
      "confirmDisableTfa": "Möchten Sie die Doppelfaktorauthentifizierung für Benutzer wirklich deaktivieren \"{0}\"?",
      "tfaDisabledSucessfully": "Doppelfaktorauthentifizierung erfolgreich deaktiviert",
      "activation-link-sent": "Aktivierungslink gesendet",
      "confirm-send-activation-link": "Möchten Sie diesem Benutzer einen Aktivierungslink senden?",
      "confirm-resend-activation-link": "Möchten Sie den Aktivierungslink an diesen Benutzer erneut senden?"
    }
  },
  "user-profile": {
    "title": {
      "page": "Benutzerprofil",
      "change-password": "Kennwort ändern"
    },
    "label": {
      "userName": "Nutzername",
      "name": "Name",
      "email": "Mail",
      "locale": "Bevorzugte Sprache",
      "currentPassword": "Jetziges Passwort",
      "newPassword": "Neues Kennwort",
      "repeatPassword": "Wiederhole das Passwort",
      "change-password": "Kennwort ändern",
      "password": "Passwort"
    },
    "message": {
      "password-changed": "das Passwort wurde erfolgreich geändert",
      "profile-updated": "Profil erfolgreich aktualisiert. Sie müssen sich erneut anmelden, um die Änderungen zu sehen",
      "password": "Aktualisieren Sie Ihr Kontopasswort, um die Sicherheit Ihres Kontos zu gewährleisten"
    }
  },
  "penalties": {
    "label": {
      "periodFrom": "Zeitraum ab",
      "periodTo": "Zeitraum bis"
    },
    "title": {
      "listPenalties": "Konfiguration der Strafen"
    }
  },
  "taxreturn-evaluation": {
    "title": {
      "page": "Überprüfung der Berichtigungen",
      "approve": "Berichtigung genehmigen",
      "reject": "Berichtigung ablehnen",
      "dialog-confirm": "Bestätigen"
    },
    "label": {
      "nit": "Steuer ID",
      "taxreturnNumber": "Deklarationsnummer",
      "country": "Land",
      "taxId": "MwSt",
      "taxreturnType": "Deklarationstyp",
      "name": "Beitragsnummer",
      "form": "Bilden",
      "approve": "Bestehen",
      "taxpayer": "Beitrag",
      "comments": "Bemerkungen",
      "general-comments": "Stammen aus",
      "periodFrom": "Datum bis",
      "periodTo": "Allgemeine Kommentare"
    },
    "header": {
      "actions": "Aktionen",
      "nit": "Steuer ID",
      "name": "Mitwirkender Name",
      "taxReturnNumber": "Deklarationsnummer",
      "form": "Bilden",
      "tax": "MwSt",
      "taxreturnStatus": "Zustand",
      "period": "Zeitraum",
      "createDate": "Datum"
    },
    "validations": {},
    "messages": {
      "approved": "Genehmigte Erklärung",
      "rejected": "Erklärung abgelehnt",
      "confirm": "Möchten Sie diese Aktion wirklich ausführen?"
    },
    "button": {
      "reject": "Ablehnen",
      "approve": "Bestehen"
    }
  },
  "security-apikey": {
    "title": {
      "page": "API-Schlüssel"
    },
    "label": {
      "name": "Nobre",
      "new-api-key": "Neuer Schlüssel",
      "expiration": "Haltbarkeitsdatum",
      "your-pat": "Ihr neues persönliches Zugriffstoken",
      "revoke-token": "Token widerrufen"
    },
    "validations": {
      "name": "Der Name des API-Schlüssels ist erforderlich",
      "expiration": "Ablaufdatum ist erforderlich"
    },
    "message": {
      "key-created": "Stellen Sie sicher, dass Sie es speichern - Sie können nicht mehr darauf zugreifen.",
      "confirm-revoke": "Sind Sie sicher, dass Sie den Token widerrufen möchten?"
    }
  },
  "audit-log": {
    "title": {
      "event-title": "Ereignisprotokolle",
      "http-title": "HTTP-Protokolle",
      "application": "App",
      "security": "Sicherheit"
    },
    "label": {
      "dateFrom": "Stammen aus",
      "dateTo": "Datum bis",
      "user": "Benutzer",
      "aggregateName": "Namensabfrage",
      "eventName": "Veranstaltungsname",
      "httpMethod": "HTTP-Methode",
      "httpStatusCode": "HTTP-Statuscode"
    },
    "header": {},
    "validations": {
      "dateRequired": "Dieses Datum ist erforderlich",
      "dateToGreaterThan": "Das Datum muss größer sein als das Ab-Datum",
      "dateLessThreeMonths": "Das Datum muss weniger als 3 Monate nach dem Ab-Datum liegen"
    },
    "messages": {}
  },
  "disable-tfa": {
    "label": {
      "title": "Deaktivieren Sie die Zwei-Faktor-Authentifizierung (2FA).",
      "disable": "Deaktivieren Sie 2FA"
    },
    "validations": {},
    "message": {
      "alert-1": "Diese Aktion deaktiviert nur 2FA.",
      "alert-2": "Durch Deaktivieren von 2FA werden die in Authentifizierungs-Apps verwendeten Schlüssel nicht geändert.",
      "alert-3": "Wenn Sie den in einer Authentifizierungs-App verwendeten Schlüssel ändern möchten, sollten Sie:",
      "alert-4": "Setzen Sie Ihre Authentifizierungsschlüssel zurück.",
      "success": "2fa wurde deaktiviert. Sie können 2fa wieder aktivieren, wenn Sie eine Authentifizierungs-App einrichten"
    }
  },
  "enable-authenticator": {
    "label": {
      "title": "Konfigurieren Sie die Authentifizierungs-App",
      "verification-code": "Verifizierungs-Schlüssel",
      "verification-code-digit": "Ziffer {{position}} von {{total}}",
      "verify": "prüfen",
      "manual-key": "Manueller Einrichtungsschlüssel",
      "copy-key": "Schlüssel kopieren",
      "key-copied": "Schlüssel wurde in die Zwischenablage kopiert.",
      "key-copied-button": "Kopiert",
      "copy-unavailable": "Der Schlüssel konnte nicht kopiert werden. Kopieren Sie ihn manuell.",
      "security-recommendations": "Sicherheitsempfehlungen",
      "security-recommendations-detail": "Bewahren Sie die Wiederherstellungscodes sicher auf und geben Sie den Einrichtungsschlüssel nicht weiter."
    },
    "validations": {
      "code": "Verifizierungs-Schlüssel ist erforderlich"
    },
    "message": {
      "instruction-1": "Laden Sie eine Authentifizierungs-App wie Microsoft Authenticator auf herunter",
      "and": "Ja",
      "or": "oder",
      "for": "damit",
      "instruction-2": "Scannen Sie den QR-Code oder geben Sie diesen Schlüssel ein",
      "instruction-3": "in Ihrer Authentifikator-App. Leerzeichen und Trennzeichen spielen keine Rolle.",
      "instruction-4": " Sobald Sie den QR-Code gescannt oder den obigen Schlüssel eingegeben haben, erhalten Sie von Ihrer Authentifizierungs-App einen eindeutigen Code. Geben Sie den Code in das Bestätigungsfeld unten ein."
    }
  },
  "recovery-codes": {
    "label": {
      "title": "Wiederherstellungscodes",
      "available-once": "Speichern Sie sie jetzt: Sie werden nicht erneut vollständig angezeigt."
    },
    "message": {
      "save-security-codes": "Bewahren Sie diese Codes an einem sicheren Ort auf.",
      "if-you-lose": "Wenn Sie Ihr Gerät verlieren und nicht über die Wiederherstellungscodes verfügen, verlieren Sie den Zugriff auf Ihr Konto."
    }
  },
  "generate-recovery-codes": {
    "label": {
      "title": "Generieren Sie Wiederherstellungscodes für die Zwei-Faktor-Authentifizierung (2FA)",
      "generate": "Generieren Sie Wiederherstellungscodes"
    },
    "validations": {},
    "message": {
      "alert-1": "Bewahren Sie diese Codes an einem sicheren Ort auf.",
      "alert-2": " Wenn Sie Ihr Gerät verlieren und nicht über die Wiederherstellungscodes verfügen, verlieren Sie den Zugriff auf Ihr Konto.",
      "alert-3": " Wenn Sie Ihr Gerät verlieren und nicht über die Wiederherstellungscodes verfügen, verlieren Sie den Zugriff auf Ihr Konto.",
      "alert-4": " Setzen Sie Ihre Authentifizierungsschlüssel zurück."
    }
  },
  "security-login": {
    "title": {
      "login": "Anmeldung"
    },
    "label": {
      "username": "Benutzer",
      "password": "Passwort",
      "rememberMe": "Mich erinnern",
      "loginButton": "Einloggen",
      "passwordRecovery": "Passwort wiederherstellen",
      "notRegistered": "Noch nicht registriert?",
      "signup": "Anmelden",
      "loginAlternative": "oder",
      "forgotPassword": " Haben Sie Ihr Passwort vergessen ?",
      "next": "Nächster",
      "forgotPasswordInstructions": "Geben Sie Ihren Benutzernamen ein und wir senden Ihnen eine E-Mail mit den Anweisungen zur Wiederherstellung",
      "externalLogin": "Externer Login",
      "captcha-placeholder": "Captcha eingeben"
    },
    "validations": {
      "usernameRequired": "Das Benutzerfeld ist erforderlich",
      "passwordRequired": "Passwort wird benötigt",
      "captchaValidationRequired": "Eine Captcha-Validierung ist erforderlich"
    }
  },
  "login-with-2fa": {
    "title": {
      "login": "Zwei-Faktor-Authentifizierung",
      "login-recovery": "Bestätigungscode abrufen"
    },
    "label": {
      "twoFactorCode": "Authentifizierungscode",
      "recoveryCode": "Wiederherstellungscode",
      "rememberBrowser": "Denken Sie an diesen Browser",
      "verificationCodeInstructions": "Geben Sie den sechsstelligen Code aus Ihrer Authentifizierungs-App ein, um fortzufahren.",
      "loginButton": "Anmeldung",
      "loginRecovery": "Melden Sie sich mit dem Wiederherstellungscode an"
    },
    "message": {
      "no-access": "Sie haben keinen Zugriff auf Ihr Authentifizierungsgerät? Sie können",
      "trustedBrowser": "Überspringen Sie die Bestätigung in diesem vertrauenswürdigen Browser.",
      "recovery-requested": " Sie haben angefordert, sich mit einem Wiederherstellungscode anzumelden. Diese Anmeldung wird erst gespeichert, wenn Sie beim Anmelden einen Authentifizierungs-App-Code angeben oder 2FA deaktivieren und erneut anmelden."
    },
    "validations": {
      "twoFactorCode": "Das Feld Authentifizierungscode ist erforderlich",
      "recoveryCode": "Das Wiederherstellungscodefeld ist erforderlich"
    }
  },
  "security-password-recovery": {
    "label": {
      "title": "Passwort wiederherstellen",
      "changePassword": "Kennwort ändern",
      "userName": "Benutzer",
      "newPassword": "Neues Kennwort",
      "repeatPassword": "Wiederhole das Passwort",
      "returnLogin": "Zurück zum Login"
    },
    "message": {
      "email-sended": "E-Mail zur Kennwortwiederherstellung gesendet",
      "password-changed": "Das Passwort wurde erfolgreich geändert"
    },
    "validations": {
      "newPassword": "Das neue Passwort muss mindestens 6 Zeichen lang sein",
      "passwordEqual": "Passwörter stimmen nicht überein"
    }
  },
  "reset-authenticator": {
    "label": {
      "title": "Installieren Sie die Authentifizierungs-App",
      "reset": "Authentifizierungsschlüssel zurücksetzen",
      "configure": "Konfigurieren Sie die Authentifizierungs-App"
    },
    "validations": {},
    "message": {
      "alert-1": "Wenn Sie Ihren Authentifizierungsschlüssel zurücksetzen, funktioniert Ihre Authentifizierungs-App erst, wenn Sie sie neu konfigurieren.",
      "alert-2": "Dieser Prozess deaktiviert 2FA, bis Sie Ihre Authentifizierungs-App überprüfen.",
      "alert-3": "Wenn Sie die Konfiguration Ihrer Authentifizierungs-App nicht abschließen, verlieren Sie möglicherweise den Zugriff auf Ihr Konto.",
      "success": "Ihr Authentifizierungsschlüssel wurde zurückgesetzt und Sie müssen Ihre Authentifizierungs-App mit dem neuen Schlüssel konfigurieren."
    }
  },
  "tfa": {
    "title": {
      "page": "Doppelfaktorauthentifizierung"
    },
    "label": {
      "title": "Zwei-Faktor-Authentifizierung (2FA)",
      "authenticator-app": "Authenticator App",
      "setup-authenticator": "Konfigurieren Sie die Authentifizierungs-App",
      "add-authenticator": "Authentifizierungs-App hinzufügen",
      "reset-authenticator": "Starten Sie die Authentifizierungs-App neu",
      "reset-recovery-codes": "Wiederherstellungscodes zurücksetzen",
      "disable-2fa": "Deaktivieren Sie 2FA",
      "forget-this-browser": "Vergiss diesen Browser",
      "status-enabled": "Aktiviert",
      "status-disabled": "Nicht eingerichtet",
      "recovery-codes-remaining": "Wiederherstellungscodes verfügbar",
      "danger-zone": "Kritische Aktionen"
    },
    "validations": {},
    "message": {
      "two-factor-forgotten": "Dieser Browser wurde vergessen. Wenn Sie sich in diesem Browser erneut anmelden, werden Sie nach Ihrem 2fa-Code gefragt.",
      "no-codes-left-1": "Sie haben keine Wiederherstellungscodes verfügbar.",
      "no-codes-left-2": "Sollte",
      "no-codes-left-3": "Generieren Sie einen neuen Satz von Wiederherstellungscodes",
      "no-codes-left-4": "bevor Sie sich mit einem Wiederherstellungscode anmelden können.",
      "some-codes-left-1": "Haben",
      "some-codes-left-2": "Wiederherstellungscode (s) verfügbar.",
      "some-codes-left-3": "Sollte",
      "some-codes-left-4": "Generieren Sie einen neuen Satz von Wiederherstellungscodes"
    }
  },
  "roles": {
    "account_reports": "Kontoberatung",
    "catalogs_admin": "Katalogmanager",
    "details_reports": "Berichtsdetail",
    "environments_admin": "Manager für Umgebungsvariablen",
    "forms_admin": "Formular-Manager",
    "management_report_admin": "Berichts-Manager",
    "notifications_admin": "Benachrichtigungs-Manager",
    "system_auditor": "System Auditor",
    "taxpayer_reports": "Beitragsberatungen",
    "taxpayers_admin": "Beitragsadministrator",
    "payments_admin": "Zahlungsmanager",
    "taxpayers_approver": "Mitwirkender Genehmiger",
    "taxreturn_approver": "Genehmiger von Erklärungen",
    "taxreturn_reports": "Deklarationsabfragen",
    "tfa_admin": "2FA Administrator",
    "users_admin": "Benutzer Manager",
    "current_account_admin": "Girokonto-Manager",
    "debt_collection_analyst": "Inkasso Analyst",
    "debt_collection_manager": "Inkasso-Manager",
    "debt_collection_officer": "Inkassobeauftragter",
    "taxpayer_communication": "Steuerzahlerkommunikation",
    "non_compliance_analyst": "Non-Compliance-Analyst",
    "collection_statistics": "Sammlungsanalyse",
    "compliance_statistics": "Non-Compliance-Analyse"
  },
  "collections": {
    "label": {
      "maximumNumberOfTaxpayers": "Maximum number of taxpayers",
      "durationProcess": "Dauer Tage",
      "descriptionProcess": "Beschreibung",
      "selectedTaxpayers": "Ausgewählt",
      "excludedTaxpayers": "Ausgeschlossen",
      "debtDetail": "Siehe Schuldendetail",
      "lastTaxreturn": "letzte Aussage.",
      "lastPayment": "Letzte Zahlung",
      "excluded": "Ausgeschlossen",
      "debtOriginal": "Ursprüngliche Schuld",
      "debtFinal": "letzte Schuld",
      "currentDebt": "Laufende Schulden",
      "code": "Kennung",
      "taxpayer": "Steuerzahler",
      "start": "Anfang",
      "end": "Das Ende",
      "newCommunication": "Neue Kommunikation",
      "typeCommunication": "Kommunikationskanal",
      "saveCommunication": "Kommunikation sparen",
      "communicationChannelPhone": "Telefon",
      "communicationChannelMail": "E-Mail",
      "process": "Process",
      "startProcess": "Started process",
      "recoveredDebt": "Debt recovered",
      "endProcess": "End process",
      "timeElapsed": "Durchschnittliche Antwort",
      "countProcess": "Prozesse",
      "countEndedProcess": "Fertig",
      "countInProgressProcess": "In Bearbeitung",
      "countTaxpayerProcess": "Steuerzahler",
      "unpaid": "Unbezahlt",
      "noCommunications": "Keine Kommunikation"
    },
    "title": {
      "detailCollection": "Zahlungsinformationen",
      "newProcessCollection": "Neuer Sammelprozess",
      "selectionTaxpayerProcess": "Auswahl der Steuerpflichtigen",
      "indicators": "Indikatoren",
      "taxreturnAndPayments": "Steuererklärungen und Zahlungen",
      "communications": "Kommunikation",
      "processCollection": "Inkassoprozesse",
      "StatisticQuery": "Beratungszeitraum",
      "StatisticQueryResult": "Ergebnisse"
    },
    "status": {
      "started": "Gestartet",
      "ended": "Beendet"
    },
    "messages": {
      "newProcessCreated": "Ein neuer Erhebungsprozess wurde mit [limit] Steuerzahlern erstellt, der am [startDate] begann und am [endDate] endet."
    }
  },
  "taxes": {
    "title": {
      "page": "Steuern verwalten"
    },
    "label": {
      "name": "Name",
      "rateType": "Tarifart",
      "shortName": "Kurzer Name",
      "code": "Code",
      "newButton": "Neu",
      "saveButton": "Behalten",
      "tabEditTax": "Allgemeines",
      "tabRates": "Gebühren",
      "rate": "Bewertung",
      "tabPeriodicity": "Periodizität",
      "tabOperations": "Operationen",
      "dateFrom": "Daten von",
      "dateTo": "Datum bis",
      "value": "Wert",
      "periodicityType": "Periodizitätstyp",
      "filingDueDay": "Verfallsdatum",
      "paymentDueDay": "Zahltag"
    },
    "header": {
      "code": "Code",
      "name": "Name",
      "rateType": "Tarifart",
      "value": "Wert",
      "dateFrom": "Daten von",
      "dateTo": "Datum bis",
      "shortName": "Kurzer Name",
      "actions": "Aktionen",
      "periodicityType": "Periodizitätstyp",
      "filingDueDay": "Verfallsdatum"
    },
    "validations": {
      "rateTypeRequired": "Das Feld für den Tariftyp ist erforderlich",
      "shortNameRequired": "Das Kurznamenfeld ist erforderlich",
      "codeRequired": "Das Codefeld ist erforderlich",
      "valueLessThan100": "Das Wertefeld muss kleiner als 100% sein",
      "valueRequired": "Das Wertefeld ist erforderlich",
      "dateFromRequired": "Das Datum vom Feld ist erforderlich",
      "dateToRequired": "Das Datum bis zum Feld ist erforderlich",
      "filingDueDayRequired": "Das Feld Verfalltag ist erforderlich",
      "periodicityTypeRequired": "Das Feld für den Periodizitätstyp ist erforderlich"
    },
    "messages": {
      "savedSuccessfully": "Wurde erfolgreich gespeichert",
      "deletedSuccessfully": "Wurde erfolgreich entfernt",
      "error": "Error"
    }
  },
  "reportOperation": {
    "title": {
      "page": "Betriebsberichte verwalten",
      "warning": "Warnung"
    },
    "label": {
      "operation": "Operation",
      "report": "Bericht"
    },
    "header": {
      "operation": "Operation",
      "report": "Bericht",
      "actions": "Aktionen"
    },
    "messages": {
      "removeReportOperation": "Sind Sie sicher, es zu löschen?"
    }
  },
  "reports": {
    "title": {
      "page": "Berichte verwalten",
      "report": "Bericht",
      "versions": "Versionen"
    },
    "label": {
      "name": "Name",
      "shortName": "Kurzer Name",
      "code": "Code",
      "newButton": "Neu",
      "saveButton": "Behalten",
      "tabEditReport": "Allgemeines",
      "tabPeriodicity": "Periodizität",
      "dateFrom": "Daten von",
      "dateTo": "Datum bis",
      "periodicityType": "Periodizitätstyp",
      "filingDueDay": "Verfallsdatum"
    },
    "header": {
      "code": "Code",
      "name": "Name",
      "shortName": "Kurzer Name",
      "actions": "Aktionen",
      "dateFrom": "Daten von",
      "dateTo": "Datum bis",
      "periodicityType": "Periodizitätstyp",
      "filingDueDay": "Verfallsdatum"
    },
    "validations": {
      "shortNameRequired": "Das Kurznamenfeld ist erforderlich",
      "codeRequired": "Das Codefeld ist erforderlich",
      "dateFromRequired": "Das Datum vom Feld ist erforderlich",
      "dateToRequired": "Das Datum bis zum Feld ist erforderlich",
      "filingDueDayRequired": "Das Feld Verfalltag ist erforderlich",
      "periodicityTypeRequired": "Das Feld für den Periodizitätstyp ist erforderlich"
    },
    "messages": {
      "savedSuccessfully": "Wurde erfolgreich gespeichert",
      "deletedSuccessfully": "Wurde erfolgreich entfernt",
      "error": "Error"
    }
  },
  "report-cells": {
    "title": {
      "page": "Boxen"
    },
    "label": {
      "code": "Box Code",
      "name": "Namensfeld",
      "description": "Beschreibung",
      "formula": "Formel",
      "order": "Auftrag",
      "type": "Nett",
      "numeric": "Numerisch",
      "currency": "Währung",
      "date": "Datum",
      "list": "Bereit",
      "text": "Text",
      "catalogType": "Katalogtyp",
      "mandatory": "Obligatorisch"
    },
    "messages": {
      "confirmTitle": "Beseitigen, abschütteln",
      "confirmDeleted": "Möchten Sie es wirklich löschen?"
    }
  },
  "report-version": {
    "title": {
      "page": "Versionsbericht"
    },
    "label": {
      "version": "Ausführung",
      "formVersion": "Versionsbericht",
      "startDate": "Stammen aus",
      "endDate": "Datum bis",
      "formCode": "Code",
      "formName": "Name",
      "since": "Schon seit",
      "tabVersion": "Ausführung",
      "fields": "Boxen"
    },
    "messages": {
      "confirmTitle": "Beseitigen, abschütteln",
      "confirmDeleted": "Sind Sie sicher, es zu löschen?"
    }
  },
  "taxOperation": {
    "title": {
      "page": "Steueroperationen verwalten",
      "warning": "Warnung"
    },
    "label": {
      "operation": "Operation",
      "tax": "MwSt"
    },
    "header": {
      "operation": "Operation",
      "tax": "MwSt",
      "actions": "Aktionen"
    },
    "messages": {
      "removeTaxOperation": "Sind Sie sicher, es zu löschen?",
      "allOperationsLinked": "Alle Vorgänge sind bereits mit dieser Steuer verknüpft",
      "noLinkedOperations": "Mit dieser Steuer sind keine Vorgänge verknüpft"
    }
  },
  "taxpayer-current-account": {
    "title": {
      "currentAccount": "Aktuelles Konto",
      "amendingCredit": "Kontostandsanfrage",
      "currentAccountTransaction": "Transaktionsdetails",
      "transactionAdjustment": "Balance-Einstellung"
    },
    "label": {
      "nit": "Steuer ID",
      "tax": "MwSt",
      "taxCode": "Kabeljau. MwSt",
      "period": "Zeitraum",
      "taxAmount": "Steuerbetrag",
      "penalty": "Bußgeld",
      "interest": "Interessen",
      "taxArrears": "Mora",
      "total": "Gesamt",
      "expirationDate": "Haltbarkeitsdatum",
      "accountType": "Konto Typ",
      "balance": "Balance",
      "date": "Datum",
      "transactionType": "Art der Transaktion",
      "value": "Wert",
      "document": "Dokument",
      "taxpayerName": "Name",
      "credit": "Gutschrift",
      "debit": "Lastschrift"
    },
    "dialog": {},
    "messages": {},
    "validations": {
      "nit-required": "ID ist erforderlich"
    }
  },
  "taxpayer-payments": {
    "title": {
      "page": "Zahlungsanfrage",
      "paymentsByJurisdiction": "Zahlungen nach Zuständigkeit",
      "pagePayments": "Zahlungs Aufzeichnung",
      "pageUploadPayments": "Zahlungen laden",
      "selectTaxReturn": "Steuererklärung auswählen",
      "reconciliationPayments": "Abgleich von Zahlungen.",
      "paymentsTaxpayer": "Vom Steuerzahler gemeldete Zahlungen",
      "paymentsTaxCollect": "Von der Inkassostelle gemeldete Zahlungen",
      "concialiation": "Schlichtung.",
      "checkBankInformation": "Bankverbindung prüfen"
    },
    "label": {
      "registerPayment": "Zahlungs Aufzeichnung",
      "amountTaxReturn": "Deklarationsbetrag",
      "totalDebt": "Gesamtschulden",
      "amountTaxpayer": "Steuerzahler Betrag",
      "amountBank": "Bankbetrag",
      "amountFrom": "Betrag ab",
      "amountTo": "Betrag bis zu",
      "tax-id": "Ruc",
      "name": "Name",
      "date-from": "Stammen aus",
      "date-to": "Datum bis",
      "date-payment": "Zahltag",
      "payment-number": "Zahlungsnummer",
      "exchange-rate": "Tauschrate",
      "local-amount": "Betrag in Landeswährung",
      "tax": "MwSt",
      "amount": "Menge",
      "excelDefinition": "Excel-Dateidefinition",
      "taxCollector": "Steuereintreiber",
      "swiftNumber": "SWIFT-Bestätigungsnummer",
      "uploadNumber": "Nummer hochladen",
      "hasErrors": "Hat Fehler",
      "date-payment-bank": "Empfangsdatum"
    },
    "messages": {
      "paymentRegisteredSucessfully": "Zahlung erfolgreich registriert am [createDate]",
      "diferentCurrencyCode": "Zahlungen verschiedener Währungen können nicht abgestimmt werden",
      "exceedsTolerance": "Überschreitet die zulässige [tolerence]% Toleranz",
      "paymentGreaterThen": "Die vom Steuerpflichtigen gemeldeten Zahlungen sind höher als die von der erhebenden Stelle gemeldeten Zahlungen"
    }
  },
  "taxpayer-report": {
    "title": {
      "page": "Beitragsberatung"
    },
    "label": {
      "name": "Name",
      "nit": "Steuer ID",
      "county": "Land",
      "personType": "Art von Person",
      "email": "Mail"
    }
  },
  "taxpayer-request": {
    "label": {
      "personType": "Personentyp",
      "businessName": "Name oder sozialer Grund",
      "fullName": "Vollständiger Name",
      "id": "Identifikationsnummer",
      "taxNumber": "Steuernummer",
      "phoneNumber": "Telefonnummer",
      "domicile": "Adresse",
      "department": "Abteilung / Provinz / Staat",
      "addContact": "Kontakt hinzufügen",
      "operations": "Operationen",
      "contacts": "Kontakte:",
      "taxVector": "Steuervektor",
      "reportVector": "Berichte",
      "generalData": "Allgemeines",
      "tax": "MwSt",
      "taxObligation": "MwSt",
      "report": "Bericht",
      "website": "Webseite",
      "idTax": "Steueridentifikationsnummer im Wohnsitzland",
      "contactName-tax": "Name des primären Kontakts",
      "docNumberContact-tax": "Kontakt-Identifikationsnummer",
      "contactTaxIdNumber-tax": "Steueridentifikationsnummer des Kontakts im Wohnsitzland",
      "phoneNumberContact-tax": "Telefonnummer des Kontakts im Wohnsitzland",
      "email-tax": "Kontakt E-mail",
      "documents": "Unterlagen",
      "docCompanyRegistrationNumber": "Firmenregistrierungsdokument",
      "docLocalContact": "Ausweis des Kontakts im Wohnsitzland",
      "acceptance": "Annahme",
      "taxpayerRequest": "POSS-Registrierung",
      "confirmTerms": "Nutzungsbedingungen akzeptieren",
      "terms": "Lorem ipsum Schmerz sitzen amet consectetur adipiscing elit per",
      "locale": "Vordefinierte Sprache",
      "queryOfRequest": "Anfrage der Anfrage",
      "acquirerId": "Erwerber-ID",
      "acquirerCountry": "Erwerberland",
      "terminalId": "Terminal-ID",
      "merchantCategoryCode": "Händlerkategorie-Code",
      "merchantId": "Händler-ID",
      "documentNumberCountryResidence": "Dokumentnummer im Land des Wohnsitzes"
    },
    "vector": {
      "label": {
        "tax": "MwSt",
        "expiration": "Verfallsdatum",
        "periodicity": "Periodizität",
        "startOperation": "Inbetriebnahme"
      }
    },
    "dialog": {},
    "messages": {
      "contacts": "Es ist mindestens ein Kontakt erforderlich",
      "operations": "Es ist mindestens eine Operation erforderlich",
      "selectOperations": "Zugehörige Operationen",
      "withoutOperations": "Keine Vorgänge",
      "withoutOperationsVector": "Es hat keine damit verbundenen Steuern",
      "withoutOperationsReport": "Es hat keine zugehörigen Berichte",
      "withoutDocuments": "Es gibt keine Dateidefinition"
    },
    "validations": {
      "acceptance": "Feld muss ausgewählt sein",
      "formComplete": "Füllen Sie das gesamte Formular aus"
    }
  },
  "taxpayer-request-val": {
    "title": {
      "page": "Anträge der Steuerzahler",
      "approve": "Anfrage genehmigen",
      "reject": "Anfrage ablehnen",
      "request-additional-info": "Fordern Sie zusätzliche Informationen an",
      "request": "Anfrage"
    },
    "label": {
      "check-digit": "Check digit",
      "date-from": "Stammen aus",
      "date-to": "Datum bis",
      "request-type": "Art der Anfrage",
      "request": "Anfrage",
      "type": "Nett",
      "taxpayer": "Beitrag",
      "state": "Zustand",
      "approve": "Bestehen",
      "reject": "Ablehnen",
      "request-additional-info": "Zurückkehren",
      "comments": "Bemerkungen",
      "reason": "Ursache",
      "createdDate": "Datum",
      "cancellationDate": "Stornierungsdatum"
    },
    "message": {
      "approved": "Antrag genehmigt",
      "rejected": "Abgelehnte Anfrage",
      "request-additional-info": "Fordern Sie zusätzliche Informationen an",
      "periodictyOutOfDate": "Eine Periodizität von Steuern oder Berichten ist nicht in Kraft"
    }
  },
  "taxpayer-taxreturns": {
    "title": {
      "page": "Siehe Erklärungen"
    },
    "label": {
      "nit": "Steuer ID",
      "taxreturnNumber": "Deklarationsnummer",
      "country": "Land",
      "formId": "Bilden",
      "taxreturnType": "Deklarationstyp",
      "taxreturnStatus": "Zustand",
      "name": "Mitwirkender Name",
      "period": "Zeitraum",
      "periodFrom": "Stammen aus",
      "periodTo": "Datum bis",
      "active": "Aktiv"
    },
    "header": {
      "actions": "Aktionen",
      "nit": "Steuer ID",
      "name": "Mitwirkender Name",
      "taxReturnNumber": "Deklarationsnummer",
      "createDate": "Datum",
      "taxreturnType": "Deklarationstyp",
      "taxreturnStatus": "Zustand",
      "form": "Bilden",
      "period": "Zeitraum",
      "active": "Aktiv"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "taxpayer-update-request": {
    "title": {
      "page": "Registrierung aktualisieren"
    }
  },
  "taxpayer-unsuscribe-request": {
    "title": {
      "page": "Ausfallen"
    }
  },
  "taxpayer-notification": {
    "title": {
      "sendMessagePage": "Nachricht senden"
    },
    "label": {
      "nit": "Steuer ID",
      "taxpayerName": "Süßkartoffel",
      "subject": "Thema",
      "message": "Nachricht"
    }
  },
  "form-administration": {
    "title": {
      "page": "Verwaltungsformular für Erklärungen",
      "form": "Bilden",
      "versions": "Versionen"
    },
    "label": {
      "code": "Code",
      "name": "Name",
      "shortName": "Kurzer Name",
      "tax": "MwSt",
      "numberModifications": "Anzahl der Änderungen",
      "amendmentApprovalRequired": "Änderungen bedürfen der Genehmigung",
      "form": "Bilden",
      "versions": "Versionen"
    },
    "header": {
      "actions": "Aktionen",
      "code": "Code",
      "name": "Name",
      "shortName": "Kurzer Name",
      "tax": "MwSt"
    },
    "messages": {
      "confirmTitle": "Beseitigen, abschütteln",
      "confirmDeleted": "Sind Sie sicher, es zu löschen?"
    }
  },
  "form-cells": {
    "title": {
      "page": "Boxen",
      "serviceParameters": "Service-Parameter",
      "serviceHeaders": "Service-Header"
    },
    "label": {
      "noFoundCells": "Das Formular hat keine definierten Zellen",
      "code": "Box Code",
      "name": "Namensfeld",
      "description": "Beschreibung",
      "section": "Abschnitt",
      "formula": "Formel",
      "order": "Auftrag",
      "type": "Nett",
      "service": "Bedienung",
      "mandatory": "Verpflichtend",
      "editable": "Bearbeitbar",
      "visible": "Sichtbar",
      "cellPurpose": "Zellzweck",
      "numeric": "Numerisch",
      "currency": "Währung",
      "date": "Datum",
      "list": "Bereit",
      "text": "Text",
      "catalogType": "Katalogtyp",
      "parameterName": "Name",
      "addParameter": "Parameter hinzufügen",
      "headerName": "Name",
      "addHeader": "Kopfzeile hinzufügen"
    },
    "messages": {
      "confirmTitle": "Beseitigen, abschütteln",
      "confirmDeleted": "Sind Sie sicher, es zu löschen?"
    }
  },
  "form-section": {
    "labels": {
      "description": "Beschreibung",
      "order": "Auftrag",
      "code": "Code",
      "isMultiple": "Mehrfachabschnitt",
      "minInstances": "Mindestinstanzen",
      "maxInstances": "Maximale Instanzen"
    }
  },
  "form-version": {
    "title": {
      "page": "Versionsformular",
      "current-account-rules": "Kontoregeln überprüfen"
    },
    "labels": {
      "noFoundVersion": "Es ist keine Version konfiguriert",
      "version": "Ausführung",
      "formVersion": "Formularversion",
      "startDate": "Anfangsdatum",
      "endDate": "Endtermin",
      "formCode": "Formularcode",
      "formName": "Formularname",
      "since": "Schon seit",
      "generalData": "Allgemeine Information",
      "fields": "Boxen",
      "sections": "Abschnitte",
      "enabled": "aktiviert",
      "preview": "Vorschau",
      "current-account-rules": "Kontoregeln überprüfen",
      "account-type-header": "Konto Typ",
      "transaction-type-header": "Art der Transaktion",
      "cell-header": "Box",
      "account-type": "Konto Typ",
      "transaction-type": "Art der Transaktion",
      "cell": "Box"
    }
  },
  "preview-form": {
    "label": {
      "preview": "Vorschau",
      "year": "Zeitraum",
      "taxpayer": "Mitwirkende Kennung",
      "nit": "Steuer ID",
      "taxpayerName": "Name des Mitwirkenden",
      "validTestTaxpayer": "Ein gültiger Steuerzahler wurde zum Testen nicht gefunden",
      "validTestTax": "Der Steuerzahler hat keine Steuer im Zusammenhang mit diesem Formular",
      "formulaLog": "Formeln Protokoll"
    },
    "messages": {
      "formVersionNotFound": "Die Version des Formulars wurde nicht gefunden",
      "taxReturnExist": "Die Erklärung ya existiert für diesen Zeitraum"
    }
  },
  "report-details": {
    "stateType": {
      "processing": "Wird bearbeitet",
      "error": "Fehler",
      "accepted": "Akzeptiert",
      "processed": "Verarbeite"
    },
    "title": {
      "page": "Konsultation von Berichten"
    },
    "label": {
      "reportNumber": "Berichtsnummer",
      "reportType": "Berichtstyp",
      "operations": "Art der Operation",
      "taxpayerNumber": "Ruc",
      "taxpayerName": "Name des Mitwirkenden",
      "registrationDate": "Registrierungsdatum",
      "period": "Zeitraum",
      "reportName": "Berichtsname",
      "record": "Werte",
      "index": "Reihe",
      "type": "Nett",
      "active": "Aktiv",
      "taxReportState": "Zustand"
    }
  },
  "payment-file-status": {
    "processing": "Wird bearbeitet",
    "error": "Fehler",
    "pending": "Ausstehend",
    "accepted": "Akzeptiert",
    "rejected": "Abgelehnt",
    "processed": "Verarbeitet",
    "received": "Empfangen"
  },
  "taxreturn-report": {
    "title": {
      "page": "Siehe Erklärungen"
    },
    "label": {
      "nit": "Steuer ID",
      "taxreturnNumber": "Deklarationsnummer",
      "country": "Land",
      "formId": "Formularname",
      "taxreturnType": "Deklarationstyp",
      "taxreturnStatus": "Zustand",
      "name": "Mitwirkender Name",
      "period": "Zeitraum",
      "periodFrom": "Stammen aus",
      "periodTo": "Datum bis",
      "active": "Aktiv",
      "overview": "Allgemeines",
      "taxreturn": "Erklärung",
      "createDate": "Datum",
      "approve": "Genehmigt",
      "comments": "Bemerkungen"
    },
    "header": {
      "actions": "Aktionen",
      "nit": "Steuer ID",
      "name": "Mitwirkender Name",
      "taxReturnNumber": "Deklarationsnummer",
      "createDate": "Datum",
      "taxreturnType": "Deklarationstyp",
      "taxreturnStatus": "Zustand",
      "form": "Bilden",
      "period": "Zeitraum",
      "active": "Aktiv",
      "rejectionReason": "Grund für die Ablehnung"
    },
    "validations": {},
    "messages": {
      "periodMessage": "Für Jahresperioden JJJJ-Format, Monats- / Quartalszeitraum JJJJMM"
    },
    "button": {},
    "message": {
      "approved": "Antrag genehmigt",
      "rejected": "Abgelehnte Anfrage",
      "request-additional-info": "Fordern Sie zusätzliche Informationen an",
      "periodictyOutOfDate": "Eine Periodizität von Steuern oder Berichten ist nicht in Kraft"
    }
  },
  "taxpayer-taxreturns": {
    "title": {
      "page": "Siehe Erklärungen"
    },
    "label": {
      "nit": "Steuer ID",
      "taxreturnNumber": "Deklarationsnummer",
      "country": "Land",
      "formId": "Bilden",
      "taxreturnType": "Deklarationstyp",
      "taxreturnStatus": "Zustand",
      "name": "Mitwirkender Name",
      "period": "Zeitraum",
      "periodFrom": "Stammen aus",
      "periodTo": "Datum bis",
      "active": "Aktiv"
    },
    "header": {
      "actions": "Aktionen",
      "nit": "Steuer ID",
      "name": "Mitwirkender Name",
      "taxReturnNumber": "Deklarationsnummer",
      "createDate": "Datum",
      "taxreturnType": "Deklarationstyp",
      "taxreturnStatus": "Zustand",
      "form": "Bilden",
      "period": "Zeitraum",
      "active": "Aktiv"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "taxpayer-update-request": {
    "title": {
      "page": "Registrierung aktualisieren"
    }
  },
  "taxpayer-unsuscribe-request": {
    "title": {
      "page": "Ausfallen"
    }
  },
  "taxpayer-notification": {
    "title": {
      "sendMessagePage": "Nachricht senden"
    },
    "label": {
      "nit": "Steuer ID",
      "taxpayerName": "Süßkartoffel",
      "subject": "Thema",
      "message": "Nachricht"
    }
  },
  "form-administration": {
    "title": {
      "page": "Verwaltungsformular für Erklärungen",
      "form": "Bilden",
      "versions": "Versionen"
    },
    "label": {
      "code": "Code",
      "name": "Name",
      "shortName": "Kurzer Name",
      "tax": "MwSt",
      "numberModifications": "Anzahl der Änderungen",
      "amendmentApprovalRequired": "Änderungen bedürfen der Genehmigung",
      "form": "Bilden",
      "versions": "Versionen"
    },
    "header": {
      "actions": "Aktionen",
      "code": "Code",
      "name": "Name",
      "shortName": "Kurzer Name",
      "tax": "MwSt"
    },
    "messages": {
      "confirmTitle": "Beseitigen, abschütteln",
      "confirmDeleted": "Sind Sie sicher, es zu löschen?"
    }
  },
  "form-cells": {
    "title": {
      "page": "Boxen",
      "serviceParameters": "Service-Parameter",
      "serviceHeaders": "Service-Header"
    },
    "label": {
      "noFoundCells": "Das Formular hat keine definierten Zellen",
      "code": "Box Code",
      "name": "Namensfeld",
      "description": "Beschreibung",
      "section": "Abschnitt",
      "formula": "Formel",
      "order": "Auftrag",
      "type": "Nett",
      "service": "Bedienung",
      "mandatory": "Verpflichtend",
      "editable": "Bearbeitbar",
      "visible": "Sichtbar",
      "cellPurpose": "Zellzweck",
      "numeric": "Numerisch",
      "currency": "Währung",
      "date": "Datum",
      "list": "Bereit",
      "text": "Text",
      "catalogType": "Katalogtyp",
      "parameterName": "Name",
      "addParameter": "Parameter hinzufügen",
      "headerName": "Name",
      "addHeader": "Kopfzeile hinzufügen"
    },
    "messages": {
      "confirmTitle": "Beseitigen, abschütteln",
      "confirmDeleted": "Sind Sie sicher, es zu löschen?"
    }
  },
  "form-section": {
    "labels": {
      "description": "Beschreibung",
      "order": "Auftrag",
      "code": "Code",
      "sectionType": "Abschnittstyp",
      "isMultiple": "Mehrfachabschnitt",
      "minInstances": "Mindestinstanzen",
      "maxInstances": "Maximale Instanzen"
    },
    "provisioning": {
      "simple": "Einfach",
      "multiple": "Mehrfach",
      "jurisdiction": "Gerichtsbarkeit"
    }
  },
  "form-version": {
    "title": {
      "page": "Versionsformular",
      "current-account-rules": "Kontoregeln überprüfen"
    },
    "labels": {
      "noFoundVersion": "Es ist keine Version konfiguriert",
      "version": "Ausführung",
      "formVersion": "Formularversion",
      "startDate": "Anfangsdatum",
      "endDate": "Endtermin",
      "formCode": "Formularcode",
      "formName": "Formularname",
      "since": "Schon seit",
      "generalData": "Allgemeine Information",
      "fields": "Boxen",
      "sections": "Abschnitte",
      "enabled": "aktiviert",
      "preview": "Vorschau",
      "current-account-rules": "Kontoregeln überprüfen",
      "account-type-header": "Konto Typ",
      "transaction-type-header": "Art der Transaktion",
      "cell-header": "Box",
      "account-type": "Konto Typ",
      "transaction-type": "Art der Transaktion",
      "cell": "Box"
    }
  },
  "preview-form": {
    "label": {
      "preview": "Vorschau",
      "year": "Zeitraum",
      "taxpayer": "Mitwirkende Kennung",
      "nit": "Steuer ID",
      "taxpayerName": "Name des Mitwirkenden",
      "validTestTaxpayer": "Ein gültiger Steuerzahler wurde zum Testen nicht gefunden",
      "validTestTax": "Der Steuerzahler hat keine Steuer im Zusammenhang mit diesem Formular",
      "formulaLog": "Formeln Protokoll"
    },
    "messages": {
      "formVersionNotFound": "Die Version des Formulars wurde nicht gefunden",
      "taxReturnExist": "Die Erklärung ya existiert für diesen Zeitraum"
    }
  },
  "report-details": {
    "stateType": {
      "processing": "Wird bearbeitet",
      "error": "Fehler",
      "accepted": "Akzeptiert",
      "processed": "Verarbeite"
    },
    "title": {
      "page": "Konsultation von Berichten"
    },
    "label": {
      "reportNumber": "Berichtsnummer",
      "reportType": "Berichtstyp",
      "operations": "Art der Operation",
      "taxpayerNumber": "Ruc",
      "taxpayerName": "Name des Mitwirkenden",
      "registrationDate": "Registrierungsdatum",
      "period": "Zeitraum",
      "reportName": "Berichtsname",
      "record": "Werte",
      "index": "Reihe",
      "type": "Nett",
      "active": "Aktiv",
      "taxReportState": "Zustand"
    }
  },
  "taxreturn-report": {
    "title": {
      "page": "Siehe Erklärungen"
    },
    "label": {
      "nit": "Steuer ID",
      "taxreturnNumber": "Deklarationsnummer",
      "country": "Land",
      "formId": "Formularname",
      "taxreturnType": "Deklarationstyp",
      "taxreturnStatus": "Zustand",
      "name": "Mitwirkender Name",
      "period": "Zeitraum",
      "periodFrom": "Stammen aus",
      "periodTo": "Datum bis",
      "active": "Aktiv",
      "overview": "Allgemeines",
      "taxreturn": "Erklärung",
      "createDate": "Datum",
      "approve": "Genehmigt",
      "comments": "Bemerkungen"
    },
    "header": {
      "actions": "Aktionen",
      "nit": "Steuer ID",
      "name": "Mitwirkender Name",
      "taxReturnNumber": "Deklarationsnummer",
      "createDate": "Datum",
      "taxreturnType": "Deklarationstyp",
      "taxreturnStatus": "Zustand",
      "form": "Bilden",
      "period": "Zeitraum",
      "active": "Aktiv",
      "rejectionReason": "Grund für die Ablehnung"
    },
    "validations": {},
    "messages": {
      "periodMessage": "Für Jahresperioden JJJJ-Format, Monats- / Quartalszeitraum JJJJMM"
    },
    "button": {}
  },
  "appMenu": {
    "audit-log-application-http": "Anwendungs-HTTP-Protokoll",
    "audit-log-security-http": "Sicherheits-HTTP-Protokoll",
    "catalog": "Kataloge",
    "collection_compliance": "Inkasso und Einhaltung",
    "collection_statistics": "Inkasso-Statistiken",
    "compliance_statistics": "Compliance-Statistiken",
    "configuration": "Einstellungen",
    "configure_penalties": "Strafenkonfiguration",
    "debt_collection_manage": "Prozesse anzeigen",
    "disable-tfa-to-user": "Zwei-Faktor-Authentifizierung deaktivieren (2FA)",
    "economy-activity": "Operationen",
    "environment-application": "Anwendungsvariablen",
    "environment-security": "Sicherheitsvariablen",
    "home-template": "Startseite-Vorlage",
    "manage-form": "Formulare",
    "manage-report-operations": "Zusätzliche Berichte-Operationen",
    "manage-report": "Zusätzliche Berichte",
    "manage-tax-operations": "Steuern-Operationen",
    "manage-tax": "Steuern",
    "management-report-payment": "Zahlungen",
    "management-report-taxpayer": "Steuerzahler",
    "management-report-taxreturn": "Steuererklärungen",
    "management-report": "Verwaltungsberichte",
    "non_compliance": "Nicht-Einhaltungskontrolle",
    "notifications-application": "Anwendungsmeldungen",
    "notifications-security": "Sicherheitsbenachrichtigungen",
    "operations": "Operationen",
    "query-payments-taxofficer": "Zahlungen auflisten",
    "report-details": "Zusatzberichte auflisten",
    "reports": "Steuererklärungen",
    "security": "Sicherheit",
    "send-message-taxpayer": "Nachricht senden",
    "statements-tax-officer": "Steuererklärungen",
    "tax-official-query-amending-credit": "Girokonto",
    "taxes": "Steuern",
    "taxofficer-check-load-payments": "Bankinformationen überprüfen",
    "taxofficer-payment-record": "Zahlungsbeleg",
    "taxofficer-reconciliation-payments": "Zahlungsabgleich",
    "taxofficer-taxreturn-payments": "Zahlungen",
    "taxofficer-transaction-adjustment": "Saldoanpassung",
    "taxofficer-upload-payments": "Bankinformationen hochladen",
    "taxpayer-feedback": "Feedback",
    "taxpayer-fields": "Steuerpflichtige Felder",
    "taxpayer-report": "Liste der Steuerpflichtigen",
    "taxpayer-requests": "Steuerpflichtige Anfragen",
    "taxpayers": "Steuerzahler",
    "taxreport-report": "Steuererklärungen auflisten",
    "taxreturn-evaluation": "Überarbeitungen",
    "terms-template": "Allgemeine Geschäftsbedingungen Vorlage",
    "two-factor-authentication": "Zwei-Faktor-Authentifizierung",
    "user-taxpayers": "Steuerzahler",
    "users": "Benutzer"
  }
}
